import { makeRule } from '@core/utils/rule.js'

export let searchRules = {
  id: [
    {...makeRule('请输入正确的测试安卓APKID', 'integer', 'blur', false), min: 1},
  ],
}

export let formRules = {
  title: [
    {...makeRule('请输入名称', 'string')},
  ],
  vision: [
    {...makeRule('请输入APK版本', 'string')},
  ],
  force_update: [
    {...makeRule('请选择是否强制升级', 'integer')},
  ],
  loadurl: [
    {...makeRule('请上传APK包', 'string')},
  ],
  apk_signature: [
    {...makeRule('请输入APK签名', 'string')},
  ],
  enable_hot_update: [
    {...makeRule('请选择是否开启热更新', 'integer')},
  ],
  force_hot_update: [
    {...makeRule('请选择是否强制热更新', 'integer')},
  ],
}



// WEBPACK FOOTER //
// ./src/views/platform-androidapk-test/platform-androidapk-test.rules.js